/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetPayJunctionResponse,
  GetTenantPersonalizationResponse,
  GetTenantResponse,
  Result,
  ResultOfCreatePayJunctionKeyResponse,
  UpdatePayJunctionRequest,
  UpdatePersonalizationRequest,
  UpdateTenantRequest,
} from '../models/index';
import {
    GetPayJunctionResponseFromJSON,
    GetPayJunctionResponseToJSON,
    GetTenantPersonalizationResponseFromJSON,
    GetTenantPersonalizationResponseToJSON,
    GetTenantResponseFromJSON,
    GetTenantResponseToJSON,
    ResultFromJSON,
    ResultToJSON,
    ResultOfCreatePayJunctionKeyResponseFromJSON,
    ResultOfCreatePayJunctionKeyResponseToJSON,
    UpdatePayJunctionRequestFromJSON,
    UpdatePayJunctionRequestToJSON,
    UpdatePersonalizationRequestFromJSON,
    UpdatePersonalizationRequestToJSON,
    UpdateTenantRequestFromJSON,
    UpdateTenantRequestToJSON,
} from '../models/index';

export interface ApiAccountPutRequest {
    updateTenantRequest: UpdateTenantRequest;
    xTenantID?: number;
}

export interface ApiAccountTenantIdGetRequest {
    tenantId: number;
    xTenantID?: number;
}

export interface ApiAccountTenantIdPayjunctionKeyPostRequest {
    tenantId: number;
    xTenantID?: number;
}

export interface ApiAccountTenantIdPayjunctionOptionsGetRequest {
    tenantId: number;
    xTenantID?: number;
}

export interface ApiAccountTenantIdPayjunctionOptionsPutRequest {
    tenantId: number;
    updatePayJunctionRequest: UpdatePayJunctionRequest;
    xTenantID?: number;
}

export interface ApiAccountTenantIdPersonalizationGetRequest {
    tenantId: number;
    xTenantID?: number;
}

export interface ApiAccountTenantIdPersonalizationPutRequest {
    tenantId: number;
    updatePersonalizationRequest: UpdatePersonalizationRequest;
    xTenantID?: number;
}

/**
 * 
 */
export class TenantApi extends runtime.BaseAPI {

    /**
     * Update account details
     */
    async apiAccountPutRaw(requestParameters: ApiAccountPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updateTenantRequest'] == null) {
            throw new runtime.RequiredError(
                'updateTenantRequest',
                'Required parameter "updateTenantRequest" was null or undefined when calling apiAccountPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/account`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateTenantRequestToJSON(requestParameters['updateTenantRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update account details
     */
    async apiAccountPut(requestParameters: ApiAccountPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAccountPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get account details
     */
    async apiAccountTenantIdGetRaw(requestParameters: ApiAccountTenantIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTenantResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling apiAccountTenantIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/account/{tenant-id}`;
        urlPath = urlPath.replace(`{${"tenant-id"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTenantResponseFromJSON(jsonValue));
    }

    /**
     * Get account details
     */
    async apiAccountTenantIdGet(requestParameters: ApiAccountTenantIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTenantResponse> {
        const response = await this.apiAccountTenantIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a PayJunction key for the specified tenant.
     * Create PayJunction Key
     */
    async apiAccountTenantIdPayjunctionKeyPostRaw(requestParameters: ApiAccountTenantIdPayjunctionKeyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfCreatePayJunctionKeyResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling apiAccountTenantIdPayjunctionKeyPost().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/account/{tenant-id}/payjunction-key`;
        urlPath = urlPath.replace(`{${"tenant-id"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfCreatePayJunctionKeyResponseFromJSON(jsonValue));
    }

    /**
     * Creates a PayJunction key for the specified tenant.
     * Create PayJunction Key
     */
    async apiAccountTenantIdPayjunctionKeyPost(requestParameters: ApiAccountTenantIdPayjunctionKeyPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfCreatePayJunctionKeyResponse> {
        const response = await this.apiAccountTenantIdPayjunctionKeyPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the PayJunction options for the specified tenant.
     * Get account PayJunction options
     */
    async apiAccountTenantIdPayjunctionOptionsGetRaw(requestParameters: ApiAccountTenantIdPayjunctionOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPayJunctionResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling apiAccountTenantIdPayjunctionOptionsGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/account/{tenant-id}/payjunction-options`;
        urlPath = urlPath.replace(`{${"tenant-id"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPayJunctionResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the PayJunction options for the specified tenant.
     * Get account PayJunction options
     */
    async apiAccountTenantIdPayjunctionOptionsGet(requestParameters: ApiAccountTenantIdPayjunctionOptionsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPayJunctionResponse> {
        const response = await this.apiAccountTenantIdPayjunctionOptionsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the PayJunction options for the specified tenant.
     * Update account PayJunction options
     */
    async apiAccountTenantIdPayjunctionOptionsPutRaw(requestParameters: ApiAccountTenantIdPayjunctionOptionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling apiAccountTenantIdPayjunctionOptionsPut().'
            );
        }

        if (requestParameters['updatePayJunctionRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePayJunctionRequest',
                'Required parameter "updatePayJunctionRequest" was null or undefined when calling apiAccountTenantIdPayjunctionOptionsPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/account/{tenant-id}/payjunction-options`;
        urlPath = urlPath.replace(`{${"tenant-id"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePayJunctionRequestToJSON(requestParameters['updatePayJunctionRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the PayJunction options for the specified tenant.
     * Update account PayJunction options
     */
    async apiAccountTenantIdPayjunctionOptionsPut(requestParameters: ApiAccountTenantIdPayjunctionOptionsPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAccountTenantIdPayjunctionOptionsPutRaw(requestParameters, initOverrides);
    }

    /**
     * Get account personalization details
     */
    async apiAccountTenantIdPersonalizationGetRaw(requestParameters: ApiAccountTenantIdPersonalizationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetTenantPersonalizationResponse>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling apiAccountTenantIdPersonalizationGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/account/{tenant-id}/personalization`;
        urlPath = urlPath.replace(`{${"tenant-id"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetTenantPersonalizationResponseFromJSON(jsonValue));
    }

    /**
     * Get account personalization details
     */
    async apiAccountTenantIdPersonalizationGet(requestParameters: ApiAccountTenantIdPersonalizationGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetTenantPersonalizationResponse> {
        const response = await this.apiAccountTenantIdPersonalizationGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update account personalization
     */
    async apiAccountTenantIdPersonalizationPutRaw(requestParameters: ApiAccountTenantIdPersonalizationPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling apiAccountTenantIdPersonalizationPut().'
            );
        }

        if (requestParameters['updatePersonalizationRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePersonalizationRequest',
                'Required parameter "updatePersonalizationRequest" was null or undefined when calling apiAccountTenantIdPersonalizationPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xTenantID'] != null) {
            headerParameters['X-Tenant-ID'] = String(requestParameters['xTenantID']);
        }

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/api/account/{tenant-id}/personalization`;
        urlPath = urlPath.replace(`{${"tenant-id"}}`, encodeURIComponent(String(requestParameters['tenantId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePersonalizationRequestToJSON(requestParameters['updatePersonalizationRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update account personalization
     */
    async apiAccountTenantIdPersonalizationPut(requestParameters: ApiAccountTenantIdPersonalizationPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiAccountTenantIdPersonalizationPutRaw(requestParameters, initOverrides);
    }

}
